import {
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { NgModel } from '@angular/forms';
import { fromEvent } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';

@Directive({ selector: '[debounce]' })
export class DebounceDirective implements OnInit {
  @Input() public delay = 400;
  @Input() public event = 'keyup';
  @Output() public debounce = new EventEmitter<any>();

  constructor(
    private model: NgModel,
    private elementRef: ElementRef
  ) {}

  public ngOnInit() {
    const eventStream = fromEvent(
      this.elementRef.nativeElement,
      this.event
    ).pipe(
      map(() => this.model.value),
      debounceTime(this.delay)
    );

    eventStream.subscribe((input) => this.debounce.emit(input));
  }
}
